// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#footer {\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  z-index: 10;\r\n\r\n  background-color: #2c3d46;\r\n  box-shadow: 0px 0px 10px #cfcfcf;\r\n}\r\n\r\n#PALogo {\r\n  height: 65px;\r\n  width: calc(height*1.785)px;\r\n  margin-top: 25px;\r\n}\r\n\r\n#live360Logo {\r\n  height: 40px;\r\n  width: calc(height*3.56)px;\r\n  margin-bottom: 25px;\r\n}", ""]);
// Exports
module.exports = exports;
